var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.454 16.769a.754.754 0 0 0 1.087 0l5.25-5.5a.75.75 0 0 0-1.084-1.034l-3.96 4.143V3.75a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v10.628l-3.956-4.147a.75.75 0 0 0-1.084 1.035l5.25 5.5z"
  })));
};
export default SvgArrowDown;